import { render } from "./App.vue?vue&type=template&id=20bc3a8b&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=20bc3a8b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bc3a8b"]])

export default __exports__